import {
  ElCheckbox,
  ElDatePicker,
  ElDialog,
  ElForm,
  ElInput,
  ElPopover,
  ElRadio,
  ElRadioButton,
  ElSelect,
} from 'element-plus'
import 'element-plus/es/components/checkbox/style/css'
import 'element-plus/es/components/date-picker/style/css'
import 'element-plus/es/components/dialog/style/css'
import 'element-plus/es/components/form/style/css'
import 'element-plus/es/components/input/style/css'
import 'element-plus/es/components/popover/style/css'
import 'element-plus/es/components/radio-button/style/css'
import 'element-plus/es/components/radio/style/css'
import 'element-plus/es/components/select/style/css'
import Inputmask from 'inputmask'
import MazPhoneNumberInput from 'maz-ui/components/MazPhoneNumberInput'
import 'maz-ui/css/main.css'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { store } from './store'

import 'styles/element-overrides.scss'
import 'styles/index.scss'

const app = createApp(App)

app.use(router)
app.use(store)
app.use(ElCheckbox)
app.use(ElDatePicker)
app.use(ElDialog)
app.use(ElForm)
app.use(ElInput)
app.use(ElPopover)
app.use(ElRadio)
app.use(ElRadioButton)
app.use(ElSelect)
app.component('MazPhoneNumberInput', MazPhoneNumberInput)

const client_id = document.querySelector('meta[name="client-id"]').getAttribute('content')

// setup({
// 	client_id: client_id,
// 	redirect_uri: window.location.origin + '/termine',
// 	automaticSilentVerification: false,
// });

app.directive('mask', {
  beforeMount(el, binding) {
    Inputmask(binding.value).mask(el.getElementsByTagName('INPUT')[0])
  },
})

app.mount('#app')
